export default {
  title: "Табла",
  subtitle: "Пациентски портал",

  // OTP entry page
  entry: {
    errorTitle: "Неуспешно вчитување на визитата",
    timeoutTitle: "Предолго чекање",
    timeoutSubtitle: "Сесијата не може да се потврди. Обидете се повторно.",
    retry: "Повторен обид",
  },

  results: {
    title: "Резултати",
    subtitle: "Лабораториски резултати",
    comingSoon: "Очекувајте наскоро",
    description: "Оваа функција ќе ви овозможи да ги прегледате вашите лабораториски резултати.",

    table: {
      examination: "Испитување",
      flag: "Знаме",
      result: "Резултат",
      units: "Единици",
      refRange: "Реф. граници",
      takenTooltip: "Датум и час на земање на примерокот",
    },

    patient: {
      title: "Пациент",
      name: "Имиња",
      dob: "Датум на раѓање",
      sex: "Пол",
      male: "Машки",
      female: "Женски",
      maleShort: "М",
      femaleShort: "Ж",
      identifier: "Идентификатор",
      visit: "Посета",
      date: "Датум на посетата",
      location: "Локација",
      copyVisit: "Копирање на бројот на посетата",
      copyPid: "Копирање на идентификаторот на пациентот",
      copied: "Копирано!",
      pid: "ЕМБГ",
      tooltipSaleSchema: "Шема на продажба",
      tooltipFund: "Оддел / Фонд",
      tooltipDoctor: "Лекар",
      tooltipVisitId: "Број на посетата",
      tooltipVisitDate: "Датум на посетата",
      tooltipCategory: "Категорија на посетата",
      tooltipLocation: "Локација на регистрација",
      tooltipRequester: "Барател",
      tooltipNotes: "Белешки",
    },

    sections: {
      results: "Резултати",
      samples: "Земени примероци",
    },

    sample: {
      barcode: "Баркод",
      taken: "Земена на",
    },

    refresh: {
      tooltip: "Освежување на резултатите",
    },

    pdf: {
      tooltip: "Преземање PDF",
    },

    email: {
      tooltip: "Испраќање по е-пошта",
    },
    flagLegend: {
      title: "Ознаки на флаговите",
    },

    colorLegend: {
      title: "Легенда за бои",
    },
    disclaimerTitle: "Медицинска забелешка",
    disclaimer:
      "Лабораториските резултати не се дијагноза, туку основа за неа. Земањето какви било лекови без рецепт може да биде опасно за вашето здравје. Ве молиме консултирајте се со квалификувани лекари за толкување на резултатите.",

    error: {
      loadFailed: "Неуспешно вчитување на резултатите. Обидете се повторно.",
      noResults: "Нема достапни резултати за оваа посета.",
      noResultsTableTitle: "Нема достапни резултати",
      noResultsTableSubtitle: "За оваа посета нема регистрирани резултати од испитувања.",
      noSamplesTableTitle: "Нема земени примероци",
      noSamplesTableSubtitle: "За оваа посета нема регистрирани земени примероци.",
      retry: "Повторен обид",
      login: "Најава",
      serverTitle: "Нешто тргна наопаку",
      serverSubtitle: "Неуспешно вчитување на резултатите. Обидете се повторно.",
      networkTitle: "Изгубена врска",
      networkSubtitle: "Нема врска со серверот. Проверете ја интернет врската.",
      timeoutTitle: "Серверот не одговори",
      timeoutSubtitle:
        "Барањето траеше предолго. Ова е обично привремено — обидете се повторно по малку.",
      authTitle: "Сесијата истече",
      authSubtitle: "Најавете се повторно.",
      unknownTitle: "Неочекувана грешка",
      unknownSubtitle: "Нешто тргна наопаку. Обидете се подоцна.",
    },

    payment: {
      overdueDialogTitle: "Чекање уплата",
      overdueDialogSubtitle: "Резултатите ќе бидат достапни по уплатата",
      overdueDialogText:
        "Вашите лабораториски резултати се готови, но пристапот до нив бара уплата на должниот износ. Ве молиме обратете се на рецепција или касата на лабораторијата.",
      overdueDialogClose: "Затвори",
      overdueAlert:
        "Пристапот до резултатите бара уплата. Ве молиме обратете се на рецепција или касата на лабораторијата.",
      overdueTableTitle: "Чекање уплата",
      overdueTableSubtitle:
        "Вашите лабораториски резултати се готови, но пристапот до нив бара уплата на должниот износ. Ве молиме обратете се на рецепција или касата на лабораторијата.",
    },
  },

  balance: {
    title: "Биланс",
    subtitle: "Биланс на плаќање",

    patient: {
      title: "Пациент",
      visit: "Посета",
      copyVisit: "Копирање на бројот на посетата",
    },

    sale: {
      title: "Продажби",
      label: "Продажба:",
      balance: "Биланс",
      copyId: "Копирање на бројот на продажбата",
      noSalesTitle: "Нема регистрирани продажби",
      noSalesSubtitle: "За оваа посета не се регистрирани продажби.",
    },

    products: {
      title: "Производи",
      product: "Производ",
      price: "Цена",
      totalLiabilities: "Вкупни обврски",
      noProductsTitle: "Нема регистрирани производи",
      noProductsSubtitle: "За оваа продажба не се регистрирани производи.",
    },

    payments: {
      title: "Плаќања",
      date: "Датум на плаќање",
      dateTooltip: "Датум и час на плаќање",
      type: "Начин на плаќање",
      amount: "Износ",
      totalPaid: "Вкупно платено",
      methods: {
        cash: "Во готово",
        card: "Кредитна/Дебитна картичка",
        unknown: "Плаќање",
      },
      noPaymentsTitle: "Нема извршени уплати",
      noPaymentsSubtitle: "За оваа продажба нема регистрирано ниту едно плаќање.",
    },

    currency: "EUR",

    refresh: {
      tooltip: "Освежување на билансот",
    },

    error: {
      loadFailed: "Неуспешно вчитување на билансот. Обидете се повторно.",
      noBalance: "Нема достапни информации за биланс за оваа посета.",
      retry: "Повторен обид",
      login: "Најава",
      serverTitle: "Нешто тргна наопаку",
      serverSubtitle: "Неуспешно вчитување на билансот. Обидете се повторно.",
      networkTitle: "Изгубена врска",
      networkSubtitle: "Нема врска со серверот. Проверете ја интернет врската.",
      timeoutTitle: "Серверот не одговори",
      timeoutSubtitle:
        "Барањето траеше предолго. Ова е обично привремено — обидете се повторно по малку.",
      authTitle: "Сесијата истече",
      authSubtitle: "Најавете се повторно.",
      unknownTitle: "Неочекувана грешка",
      unknownSubtitle: "Нешто тргна наопаку. Обидете се подоцна.",
    },
  },
};
